export class BankAccountHelper {

    static sanitizeBankAccountNumber(s: string) {
        return (s && s.length > 4) ? `*${s.substring(s.length - 4)}` : null;
    }
}

